import { useEffect, useState } from 'react';

import { useFlags, useFlagsmith } from 'flagsmith/react';

const TIMEOUT = 500;

export const useFeatureFlags = () => {
  const [isLoading, setIsLoading] = useState(true);

  const flagsmith = useFlagsmith();

  const features = ['intercom_implementation', 'mix_panel_implementation', 'new_relic'];

  const flags = useFlags(features);

  useEffect(() => {
    if (flags) setTimeout(() => setIsLoading(false), TIMEOUT);
  }, [flags]);

  const logout = () => {
    flagsmith.logout();
  };

  return {
    flags,
    flagsmith,
    isLoading,
    logout,
  };
};
